import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=c617f30e&"
import script from "./SelectOption.vue?vue&type=script&lang=ts&"
export * from "./SelectOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports